import { INotPlayerDictionaryApi } from '@/types';

export class NotPlayerDictionaryItem {
    id: number;
    login?: string;
    name: string;

    constructor(data: INotPlayerDictionaryApi) {
        this.id = data.id;
        this.name = data.name;
        this.login = data.login;
    }
}
